/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CustomerOfferChapterReview} from "./customerOfferChapterReview.zod";
import {CustomerOfferPermittedAction} from "./customerOfferPermittedAction.zod";
import {CustomerOfferStatus} from "./customerOfferStatus.zod";

export const customerOfferWorkflowMutationVersionRegExp = new RegExp("^(0|[1-9][0-9]*)$");

export const CustomerOfferWorkflow = zod
  .object({
    mutationVersion: zod
      .string()
      .regex(customerOfferWorkflowMutationVersionRegExp)
      .describe(
        "Server mutation\/decision stamp, not successor revision version or caller input. Nonnegative, starting at zero on creation. Decimal string preserves exact wire precision.",
      ),
    latestRevision: zod.boolean(),
    contentEligible: zod.boolean(),
    coefficientsComplete: zod.boolean(),
    canReadCoefficients: zod.boolean(),
    coefficientReviewerUserId: zod.uuid().nullable(),
    obsoleteFromStatus: zod.union([CustomerOfferStatus, zod.null()]),
    chapters: zod.array(CustomerOfferChapterReview),
    permittedActions: zod.array(CustomerOfferPermittedAction),
  })
  .describe(
    "Read-only workflow feedback captured by backend, not inferred from a client list page. Source qualification and coefficient completeness do not silently change lifecycle. Capabilities may become stale before a write; they never replace authoritative command checks. No coefficient value belongs in this public-safe structure.",
  );

export type CustomerOfferWorkflow = zod.input<typeof CustomerOfferWorkflow>;
export type CustomerOfferWorkflowOutput = zod.output<typeof CustomerOfferWorkflow>;
